var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.contentWidth === 'boxed' ? 'container p-0' : null},[_vm._t("default",function(){return [_c('router-view')]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }